import { IeLynxObject } from "../../common/models/eLynxObject";

export const keys = {
    all: ["object-view-state"],
    object: (
        customerID: number,
        groupID: number,
        eLynxObject?: IeLynxObject,
        offline?: boolean
    ) => [
            ...keys.all,
            "object",
            eLynxObject
                ? {
                    customerID,
                    groupID,
                    objectType: eLynxObject?.objectType,
                    objectID: eLynxObject?.id,
                    offline: offline ?? false
                }
                : "none"
        ]
};
